export default __webpack_public_path__ + "static/media/desk7.a134d049.png";